module.exports = __webpack_public_path__ + "img/dep_coffeeandtea.de651575.png";